import {Action, PayloadAction} from '@reduxjs/toolkit';
import { createSlice } from 'utils/@reduxjs/toolkit'; // Importing from `utils` makes them more type-safe ✅
import { VoiceModelsState } from './types';
import {useInjectReducer, useInjectSaga, SagaInjectionModes } from "redux-injectors";
import voiceModelsSaga from "app/pages/VoiceModelsPage/slice/saga";


// The initial state of the Voice Models page
export const initialState: VoiceModelsState = {
    voices: [],
    publicVoices: [],
    ttsVoices: [],
    ttsPublicVoices: [],
    isLoading: false,
    selectedPreviewVoice: undefined,
};

const slice = createSlice({
    name: 'voiceModels',
    initialState,
    reducers: {
        fetchVoices(state, action: Action<any>) {
            console.log("fetchVoicesReducer");
            // Saga side effect will make api call
            state.isLoading = true;
        },
        updateVoices(state, action: PayloadAction<any>) {
            // @ts-ignore
            state.voices = action.payload.voices;
            state.publicVoices = action.payload.publicVoices;
            state.isLoading = false;
        },
        fetchVoicesError(state, action: PayloadAction<any>) {
            state.isLoading = false;
        },
        fetchTtsVoices(state, action: PayloadAction<any>) {
            state.isLoading = true;
        },
        updateTtsVoices(state, action: PayloadAction<any>) {
            state.ttsVoices = action.payload.ttsVoices;
            state.ttsPublicVoices = action.payload.ttsPublicVoices;
            state.isLoading = false;
        },
        fetchTtsVoicesError(state, action: PayloadAction<any>) {
            state.isLoading = false;
        },
        appendVoice(state, action: PayloadAction<any>) {
            // @ts-ignore
            state.voices = [action.payload, ...state.voices];
        },
        deleteVoice(state, action: PayloadAction<any>) {
            const { id: voiceModelId } = action.payload;
            // @ts-ignore
            state.voices = [...state.voices].filter(v => v.id !== voiceModelId);
        },
        updateVoice(state, action: PayloadAction<any>) {
            const { id: voiceModelId, updates } = action.payload;
            // @ts-ignore
            state.voices = state.voices.map(voice => 
                voice.id === voiceModelId 
                    ? { ...voice, ...updates }
                    : voice
            );
        },
        setSelectedPreviewVoice(state, action: PayloadAction<any>) {
            state.selectedPreviewVoice = action.payload
        }
    },
});

/**
 * Let's turn this into a hook style usage. This will inject the slice to redux store and return actions in case you want to use in the component
 */
export const useVoiceModelsSlice = () => {
    useInjectReducer({ key: slice.name, reducer: slice.reducer });
    useInjectSaga({ key: slice.name, saga: voiceModelsSaga, mode: SagaInjectionModes.DAEMON });
    return { actions: slice.actions };
};
export const voiceModelActions = slice.actions